export const ONE_MAP_URL =
  "https://www.onemap.gov.sg/api/common/elastic/search";
